import AddIcon from "@mui/icons-material/AddCircleRounded";
import { Button, Grid, Stack, Typography } from "@mui/material";
import { FormikProps } from "formik";

import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { CourtFormType } from "@/pages/system-settings/tabs/courts/vienna/components/court-dialog/court-form-fields/CourtForm.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<CourtFormType>;
  index: number;
}

export function SingleDatesDayFields({ formik, index }: Props) {
  const { t } = useTranslation();
  const base = `courtDays.${index}` as const;
  const day = formik.values.courtDays[index];

  if (!day) {
    return null;
  }

  const handleAddDate = () => {
    void formik.setFieldValue(`${base}.dates`, [...day.dates, null]);
  };

  const handleRemoveDate = (dateIndex: number) => {
    void formik.setFieldValue(
      `${base}.dates`,
      day.dates.filter((_, i) => i !== dateIndex)
    );
  };

  return (
    <Grid size={12}>
      <Stack gap={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="subtitle2">{t("settings.courts.gerichtstag.singleDates")}</Typography>
          <Typography variant="caption" color="text.secondary">
            {t("settings.courts.gerichtstag.dateCount", { count: day.dates.length })}
          </Typography>
        </Stack>
        <Grid container columnSpacing={2} rowSpacing={2} alignItems="flex-start">
          {day.dates.map((_, dateIndex) => (
            <Grid key={dateIndex} size={3}>
              <FormikDatePicker
                formik={formik}
                path={`${base}.dates.${dateIndex}`}
                label={t("settings.courts.gerichtstag.date")}
                clearable
                onClear={() => handleRemoveDate(dateIndex)}
                onChange={(value: Date | null) => {
                  if (value) {
                    void formik.setFieldValue(`${base}.dates.${dateIndex}`, value, false);
                  }
                }}
              />
            </Grid>
          ))}
          <Grid size="auto">
            <Button variant="outlined" startIcon={<AddIcon />} onClick={handleAddDate}>
              {t("settings.courts.gerichtstag.addDate")}
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Grid>
  );
}
